import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import { applicationsProviderListTable } from "../../../shared/tableObjects/provider/applicationsProviderListTable";
import { useAccount, useMsal } from "@azure/msal-react";
import { AccountInfo } from "@azure/msal-browser";

export default function ApplicationsProviderList() {
  const apiClient = useApiClient("BaseApplication");
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {}) as AccountInfo;
  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Applications",
      icon: "list-icon icon-spec",
    },
  ];
  const providerIds = account?.idTokenClaims?.["extension_ProviderIds"];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <Table
          apiClient={apiClient}
          label={""}
          columns={applicationsProviderListTable("applications")}
          route={`allProviderApplication/${providerIds}`}
        />
      </div>
    </>
  );
}
